import { recordDetailsZh, recordDetailsEn } from "./recordDetails-messages";

export default {
    zh: {
        tabbar: {
            situationAssessment: "农情研判",
            agriFile: "农事档案",
            agriRecord: "农事规划",
            schedule: "农事列表",
        },
        common: {
            current: "当前",
            demoFarm: "示范农场",
            expandMore: "点击展开更多",
            collapse: "点击收起",
            backgroundDesc: "背景描述：",
            suggestion: "对策建议：",
            unlock: "点击解锁",
            noAddress: "暂无地址",
            droughtWarning: "阴雨渍水",
            cancel: "取消",
            confirm: "确认",
        },
        week: {
            0: "周日",
            1: "周一",
            2: "周二",
            3: "周三",
            4: "周四",
            5: "周五",
            6: "周六",
        },
        weather: {
            farmList: "农场列表",
            farmListGuide: "查看全部农场列表，并可创建农场",
            expandMore: "展开更多",
            collapse: "收起",
            farmInfoMaintain: "农场信息维护",
            future7Days: "未来七天天气",
            searchFarm: "搜索农场",
            selectRegion: "选择地区",
            selectCategory: "选择品类",
            sunny: "晴天",
            reportTab: {
                historyRisk: "历史气象灾害",
                soilImprovement: "土壤问题研判",
                rotationAdvice: "种植轮作建议",
            },
        },
        garden: {
            currentFarm: "当前农场",
            setDefaultFarm: "设为默认农场",
            enterFarm: "进入农场",
            enterFarmSuccess: "已切换农场",
            addFarm: "新增农场",
            currentPhenology: "当前物候：",
            phenologyPlaceholder: "暂无物候信息",
            pendingExecute: "待执行",
            taskNamePlaceholder: "农事名称",
            forward: "转发",
            forwardTip: "转发功能即将开放",
            inviteFarmer: "邀请农户",
            inviteService: "邀请农服",
            inviteTip: "邀请功能即将开放",
            noFarm: "暂无农场",
            statFarm11: "农事11",
            statFarm22: "农事22",
            statSomeRisk: "某某风险",
            statStandardFarm: "标准农事",
            statStandardControl: "标准防治",
        },
        growthStageTimeline: {
            tooltipHint: "此为预估进程，请左右移动进行校准!",
        },
        growthReport: {
            title: "长势报告",
            cropTitle: "作物长势报告",
            expand: "展开",
            weatherRiskReport: "气象风险报告",
            switchCategory: "切换品类",
            noRiskData: "暂无气象风险数据",
            weatherRisk: "气象风险",
            cropLychee: "荔枝",
            phenologyFruitExpansion: "转色期",
            phenologyLateTillering: "拔节孕穗期",
            inStage: "处于{stage}",
            futureWeatherRisk: "未来7-15天气象风险",
            farmAdvice: "农事建议",
            patrolFocus: "巡园重点",
            bindSuccess: "您的农场已绑定成功",
            lockTitle: "专属数字农场，种好卖好",
            lockSub: "点击解锁一键溯源增产",
            risk: {
                pest: {
                    title: "高温干旱风险",
                    titleRice: "连续阴雨风险",
                    desc: "经过飞鸟智慧大脑计算气象风险：高温干旱胁迫指数处于中等水平，存在果皮灼伤风险，局部区域可能会对果实品质造成伤害，需加强监测预警，及时执行相关农事。",
                    descRice: "经过飞鸟智慧大脑计算气象风险：连续阴雨胁迫指数处于中等水平，需持续关注田里水分情况，做好排水工作。",
                },
                rain: {
                    title: "阴雨寡照风险",
                    desc: "经过飞鸟智慧大脑计气象风险:阴雨寡照胁迫指数处于中等水平，存在一定的植株缺素风险，局部区域可能会出现长势异常现象，需加强监测预警，及时巡园",
                },
            },
            advice: {
                foliar: {
                    title: "喷灌降温",
                    desc: "荔枝转色期遭遇高温干旱风险，需及时喷撒清水，降低果园小气候与果皮表面温度，预防果皮灼伤。",
                    titleRice: "排水",
                    descRice: "当前连续阴雨胁迫指数处于中等水平，需日常巡园查看田中水层高度是否合适，若水分过多需及时排水，避免影响后续的孕穗进程。",
                },
                pestControl: {
                    title: "虫害防治",
                    desc: "通过叶面喷施针对性杀虫剂，快速压低蒂蛀虫种群数量，保护果实免受蛀害。",
                },
            },
            patrol: {
                process: {
                    title: "进程互动",
                    desc: "是否有5%的荔枝进入果实转色期？",
                    descRice: "是否有60%的水稻进入拔节期？",
                },
                growth: {
                    title: "长势互动",
                    desc: "是否有10%的荔枝抽生新梢？",
                    descRice: "是否有10%的水稻出现干旱缺素症状？",
                },
                pest: {
                    title: "病虫互动",
                    desc: "是否有10%的荔枝发现蒂蛀虫为害特征？",
                },
            },
        },
        adjustPopup: {
            title: "当前日期：{date}",
            selectPhenology: "请选择当前{species}的物候期",
            selectReproductive: "请选择当前{species}的生育期",
            standard: "界定标准：{ratio} 以上表型进入该阶段",
            ratio: "六成",
            selectPhenologyToast: "请选择物候期",
            selectReproductiveToast: "请选择生育期",
        },
        agriFile: {
            farmName: "农场名称",
            farmLocation: "--",
            moreFarms: "更多农场",
            patrolRecord: "巡园记录",
            patrolGrowthTitle: "物候跟踪巡园要点",
            patrolAbnormalTitle: "异常态势巡园要点",
            patrolSubject: "--",
            patrolIssue: "暂无数据",
            forward: "转发",
            workName: "农事名称",
            interactTheme: "互动主题",
            interactReason: "--",
            agriAssessment: "农情研判",
            agriAssessmentDesc: "---",
            interactQuestion: "互动问题",
            interactQuestionText: "--",
            ratioPlaceholder: "请输入比例",
            pleaseSelectOption: "请先选择一个选项",
            submit: "提交",
            submitSuccess: "提交成功",
            referenceImage: "参考图片",
            patrolGuide: "巡园向导",
            growthAbnormal: "长势异常",
            rootAbnormal: "根系异常类",
            uploadPhoto: "上传照片",
            pestInteract: "病虫害互动",
            selectAbnormalPlot: "请选择发生异常的地块",
            confirmPlot: "确认地块",
            pleaseSelectPlot: "请先选择地块",
            cancel: "取消",
            completeFarmInfo: "完善农场信息",
            getImmediately: "马上获取",
            patrolDiagnosisService: "巡田诊断服务",
            goEnable: "去开启",
            plantingDiagnosisReport: "种植诊断报告",
            reportGenerated: "已生成",
            clickToView: "点击查看",
            viewInDiagnosisHint: "还可在 农事档案-诊断报告 中查看",
            initialReport: "种植诊断报告",
            forwardReport: "转发报告",
            confirmLeaveTitle: "确认要离开？",
            confirmLeaveDesc1: "长势巡园比例还没回答，确定要走吗？",
            confirmLeaveDesc2: "少了这一步，估产数据就不准了哦～",
            continueRecord: "继续记录",
            confirmLeave: "确认离开",
            agriAlbum: "农情相册",
            diagnosisReport: "诊断报告",
            diagnosisReportGuidePrefix: "按照巡园要点 ",
            diagnosisReportGuideSuffix: " 可获得种植诊断报告",
            reportUpdate: "更新",
            restoreFillQuestions: "填写以下问题",
            restorePlantingService: "立即恢复种植服务",
            selectTime: "选择时间",
            changeQuestion: "更换问题",
            confirmNow: "立即确认",
            submitInfo: "提交信息",
            viewPatrolGuide: "查看巡园向导",
            notReached: "暂未到达",
            reached: "已到达",
            passed: "已过",
            reportTitle: "标题",
            reportDesc: "主题主题主题主题主题主题主题主题主题主题主题主题主题主题主题主题",
            reportDate: "8月30日",
            addZone: "新增分区",
            drawFarmArea: "勾画区域",
            addAlbum: "新增相册",
            selectZoneHint: "请勾选新增分区的范围",
            drawFarmAreaHint: "请勾画农场区域",
            drawFarmAreaSuccess: "勾画农场区域成功",
            searchLocation: "搜索位置",
            defaultCity: "武汉市",
            cancelSelect: "取消勾选",
            plantCrop: "种植作物",
            cropCategory: "品类",
            cropVariety: "品种",
            plantStartPoint: "起种点问题",
            selectTime: "选择时间",
            regionName: "区域名称",
            regionNamePlaceholder: "请输入区域名称",
            pleaseSelectCategory: "请选择品类",
            pleaseSelectVariety: "请选择品种",
            pleaseSelectPlantDate: "请选择种植时间",
            pleaseInputRegionName: "请输入区域名称",
            confirmArea: "确认区域",
            pleaseDrawZone: "请先勾画分区区域",
            createZoneSuccess: "分区创建成功",
            phenologyInconsistent: "物候不一致？",
            customizeZoneHint: "为了更好记录长势，请自定义分区",
            zoneTwo: "分区二",
            photoCount: "{count}张",
            emptyAlbumTip: "上传作物照片，记录作物长势",
            zoneLabel: "分区{n}",
            zoneOne: "分区一",
            legendZone: "管理分区",
            legendGrowth: "长势异常",
            legendPest: "病虫害异常",
            scaleNormal: "普通",
            scaleGood: "良好",
            scaleExcellent: "优秀",
            loading: "加载中...",
            noRecord: "暂无记录",
            noData: "暂无数据",
            tabPhenology: "物候进程",
            tabAbnormal: "异常记录",
            tabFarming: "农事记录",
            tabAgriRecord: "农情记录",
            cropArchive: "作物档案",
            yearLabel: "{year}年",
            cropArchiveMetric: "某某指标已来 20% 指标",
            cropArchiveAbnormal: "发现了 *** 异常",
            tabRemoteSensing: "时序遥感指标",
            remoteSensingChartTitle: "时序遥感指数",
            remoteSensingChartTitleNdvi: "NDVI",
            remoteSensingChartTitleNdwi: "NDWI",
            remoteSensingChartTitlePrecipitation: "日降水量",
            remoteSensingLegendZone: "区域指数曲线",
            remoteSensingLegendStandard: "标准指数曲线",
            remoteSensingLegendNdvi: "NDVI曲线",
            remoteSensingLegendNdwi: "NDWI曲线",
            remoteSensingLegendPrecipitation: "降水量",
            remoteSensingLegendAvgPrecipitation: "平均降水量",
            remoteSensingAxisIndex: "指数",
            remoteSensingAxisPrecipitation: "降水量",
            timeAxisLabel: "时间",
            remoteSensingValuePlaceholder: "数字",
            remoteSensingSelectHint: "可在左侧选项卡选择遥感指标类型查看时序指标",
            recordFruitExpand: "果园出现果实迅速膨大，占比",
            recordFruitSet: "果园出现谢花坐果，占比",
            recordFullBloom: "果园进入盛花期",
            recordPanicle: "果园出现花穗抽生",
            recordStemBorerFruit: "果园出现蒂蛀虫为害果，占比",
            recordCalciumCrack: "果园出现缺钙裂果症状，占比",
            recordStinkBug: "果园出现荔枝蝽象若虫为害",
            recordFlowerNoFruit: "果园出现花而不实现象",
            recordFertilize: "执行了膨果壮果追肥农事",
            recordStemBorerControl: "执行了蒂蛀虫防治农事",
            recordFlowerFruitProtect: "执行了保花保果药剂喷施农事",
            recordPreFlowerPest: "执行了花前病虫综合防治农事",
            recordNow: "立即记录",
            riskLevel1: "一级",
            riskLevel2: "二级",
            riskLevel3: "三级",
        },
        recordDetails: recordDetailsZh,
        agriRecord: {
            farmDetail: "农场详情",
            allFarmWork: "全部农事",
            traceFarmWork: "溯源农事",
            level2: "二级",
            riskLevel: "{level}级",
            pendingRecord: "待记录",
            growthWorkName: "长势异常态势跟踪",
            growthReason: "缺锌导致生长缓慢",
            growthIssue: "是否有10%的荔枝出现落果裂果?",
            pestWorkName: "病虫害态势监控",
            pestReason: "病虫害影响作物生长",
            pestIssue: "是否有10%的荔枝发现蒂蛀虫？",
            phenologyWorkName: "物候跟踪记录",
            phenologyReason: "预计到达病虫防控关键期",
            phenologyIssue: "是否有60%的荔枝进入转色期",
            workStatus: {
                0: "时间待校准",
                1: "触发待巡园",
                2: "待执行",
                3: "未激活",
                4: "已认证",
                5: "已失效",
                6: "已执行",
            },
        },
        workDetail: {
            title: "农事详情",
            certifiedSuccess: "已认证成功",
            ownedPlot: "权属田块1：",
            executionArea: "执行区域",
            verified: "已认证",
            reason: "农事原因",
            purpose: "农事目的",
            notes: "注意事项",
            prescription: "药肥处方",
            plantingPlan: "种植方案",
            triggerCondition: "触发条件",
            executionMethod: "执行方式",
            executeParameters: "执行参数",
            agriMaterial: "农资信息",
            usageMethod: "使用方法",
        },
        workExecute: {
            pending: "待接受",
            accepted: "已接受",
            executing: "执行中",
            completed: "已完成",
            timeout: "已超时",
            unqualified: "未达标",
            acceptTimeout: "接受异常",
            executeAbnormal: "执行异常",
            completeAbnormal: "完成异常",
            executeTimeout: "执行超时",
            completeTimeout: "完成超时",
            farmWorkType: "农事类型",
            farmFilter: "农场筛选",
            batchAccept: "批量接受",
            responsible: "负责人：",
            farmWorkDetail: "农事详情：",
            farmSituation: "农情研判：",
            executeTime: "执行时间",
            executeArea: "执行区域",
            executeMachine: "执行农机",
            executePhotos: "执行照片",
            unqualifiedReason: "未达标原因：",
            defaultUnqualifiedReason: "未在合适时间执行，药液未充分喷撒吸收",
            before: "前",
            after: "后",
            fromFarm: "来自某某农场农场",
            noData: "近期暂无待做农事",
            all: "全部",
            highRisk: "高风险",
            executeAreaLabel: "执行区域：",
            forward: "转发",
            viewDetail: "查看详情",
            forwardTip: "转发功能即将开放",
            exclusiveFarmCalendar: "专属农事日历",
            fillSurvey: "填写调查问卷",
            fillSurveyDesc: "更方便为您分配农场任务",
            fillNow: "立即填写",
            surveyEntryTitle: "录入信息",
            surveyEntryHint: "请勾选您希望由专业服务团队",
            surveyEntryHint2: "帮您服务的农事类别",
            surveySearchPlaceholder: "请输入农事类别",
            surveySearch: "搜索",
            surveySelectTitle: "选择农事类别",
            surveySelectHint: "可多选",
            surveySubmit: "提交信息",
            surveyPleaseSelect: "请至少选择一个农事类别",
            surveySubmitSuccess: "提交成功",
            surveyNoMatch: "暂无匹配类别",
            redispatch: "重新派发",
            remindAccept: "提醒接受",
            modifyInfo: "修改信息",
            acceptTask: "我要接受",
            startExecute: "开始执行",
            markComplete: "我已完成",
            remindExecute: "提醒执行",
            remindComplete: "提醒完成",
            redispatchAgain: "重新下发",
            remindSuccess: "提醒成功！",
            redispatchMsg: "重新派发：{name}",
        },
        uploadPopup: {
            uploadPhotos: "上传照片",
            optional: "(可选)",
        },
        agriRecordDetail: {
            title: "农事详情",
            deadlinePrefix: "截止到",
            executionArea: "执行区域",
            navigateHere: "导航到这里",
            workPurpose: "农事目的",
            drugPrescription: "药物处方",
            executionParams: "执行参数",
            precautions: "注意事项",
            cancelEdit: "取消修改",
            modifyInfo: "修改信息",
            saveInfo: "保存信息",
            acceptTask: "我要接受",
            saveSuccess: "保存成功",
            acceptSuccessTitle: "您已接受成功",
            acceptSuccessDesc: "请在设置的执行时间内执行农事",
            executeSuccessTitle: "农事任务已生效",
            executeSuccessDesc: "请立即按要求实地执行",
            executeSuccessNotice: "注：执行中需拍摄照片，任务完成后需提交照片审核！",
            auditApproved: "审核通过",
            completePopup: {
                selectExecuteTime: "请选择实际执行时间",
                evidenceTitle: "农事凭证",
                evidenceHint: "请上传执行照片",
                confirm: "确认信息",
                selectTimeRequired: "请选择实际执行时间",
                uploadRequired: "请上传执行照片",
                uploadFailed: "图片上传失败，请稍后再试！",
            },
            selectDate: "请选择日期",
            pleaseInput: "请输入",
            fields: {
                executor: "负责人",
                workReasonDetail: "农事详情",
                cropConditionAnalysis: "农情研判",
                workTime: "执行时间",
                executionMethod: "执行参数",
            },
            farmWorkType: {
                1: "标准农事",
                2: "机动农事",
                3: "气象预警农事",
                4: "气象恢复农事",
                5: "异常农事",
                6: "标准施肥类",
                7: "标准防治类",
                8: "标准调节类",
                91: "标准感知",
                92: "营养评估",
                93: "物候分区",
                94: "产量估计",
                95: "复核感知",
                96: "气象胁迫",
                97: "异常感知",
                98: "虫情感知",
            },
        },
    },
    en: {
        tabbar: {
            situationAssessment: "Situation Assessment",
            agriFile: "Crop Archives",
            agriRecord: "Farm Planning",
            schedule: "Schedule",
        },
        common: {
            current: "Current",
            demoFarm: "Demo Farm",
            expandMore: "Show more",
            collapse: "Collapse",
            backgroundDesc: "Background: ",
            suggestion: "Recommendations: ",
            unlock: "Unlock",
            noAddress: "No address",
            droughtWarning: "Rain & waterlogging",
            cancel: "Cancel",
            confirm: "Confirm",
        },
        week: {
            0: "Sun",
            1: "Mon",
            2: "Tue",
            3: "Wed",
            4: "Thu",
            5: "Fri",
            6: "Sat",
        },
        weather: {
            farmList: "Farm list",
            farmListGuide: "View all farms and create new ones",
            expandMore: "Expand",
            collapse: "Collapse",
            farmInfoMaintain: "Farm profile",
            future7Days: "7-day forecast",
            searchFarm: "Search farms",
            selectRegion: "Region",
            selectCategory: "Category",
            sunny: "Sunny",
            reportTab: {
                historyRisk: "Weather hist.",
                soilImprovement: "Soil issues",
                rotationAdvice: "Rotation",
            },
        },
        garden: {
            currentFarm: "Current farm",
            setDefaultFarm: "Set as default",
            enterFarm: "Enter farm",
            enterFarmSuccess: "Farm switched",
            addFarm: "Add farm",
            currentPhenology: "Current phenology: ",
            phenologyPlaceholder: "No phenology info",
            pendingExecute: "Pending",
            taskNamePlaceholder: "Task name",
            forward: "Forward",
            forwardTip: "Forward feature coming soon",
            inviteFarmer: "Invite farmer",
            inviteService: "Invite agri service",
            inviteTip: "Invite feature coming soon",
            noFarm: "No farms",
            statFarm11: "Farm Work 11",
            statFarm22: "Farm Work 22",
            statSomeRisk: "Risk Alert",
            statStandardFarm: "Standard Farm Work",
            statStandardControl: "Standard Control",
        },
        growthStageTimeline: {
            tooltipHint: "This is an estimated progress. Drag left or right to calibrate.",
        },
        growthReport: {
            title: "Growth Report",
            cropTitle: "Crop Growth Report",
            expand: "Expand",
            weatherRiskReport: "Weather RiskReport",
            switchCategory: "Switch category",
            noRiskData: "No weather risk data",
            weatherRisk: "Weather risks",
            cropLychee: "Lychee",
            phenologyFruitExpansion: "Color change stage",
            phenologyLateTillering: "Jointing and booting stage",
            inStage: "in {stage}",
            futureWeatherRisk: "7–15 day weather risks",
            farmAdvice: "Farming advice",
            patrolFocus: "Patrol priorities",
            bindSuccess: "Your farm has been linked successfully",
            lockTitle: "Your digital farm — grow better, sell better",
            lockSub: "Tap to unlock traceability & yield boost",
            risk: {
                pest: {
                    title: "High temperature & drought risk",
                    titleRice: "Continuous rain risk",
                    desc: "Feiniao AI weather risk assessment: moderate heat and drought stress index. Sunscald on fruit peel is possible; local areas may suffer fruit quality damage. Strengthen monitoring and early warning, and implement related farm practices promptly.",
                    descRice: "Feiniao AI weather risk assessment: continuous rain stress index is at a moderate level. Monitor field moisture closely and ensure proper drainage.",
                },
                rain: {
                    title: "Rain & low-light risk",
                    desc: "Feiniao AI weather assessment: moderate rain/low-light stress. Nutrient deficiency may occur in some areas with abnormal growth — strengthen monitoring and patrols.",
                },
            },
            advice: {
                foliar: {
                    title: "Sprinkler cooling",
                    desc: "During the lychee color-change stage, heat and drought pose a risk. Spray clean water promptly to lower orchard microclimate and fruit peel surface temperature, and prevent fruit peel sunscald.",
                    titleRice: "Drainage",
                    descRice: "Continuous rain stress index is currently at a moderate level. Patrol fields daily to check whether the water layer is appropriate; drain promptly if there is excess water to avoid affecting subsequent booting progress.",
                },
                pestControl: {
                    title: "Pest control",
                    desc: "Targeted foliar insecticides can quickly reduce litchi stem borer populations and protect fruit from damage.",
                },
            },
            patrol: {
                process: {
                    title: "Progress check",
                    desc: "Have 5% of lychee trees entered fruit color-change stage?",
                    descRice: "Have 60% of rice entered jointing stage?",
                },
                growth: {
                    title: "Growth check",
                    desc: "Have 10% of lychee trees produced new shoots?",
                    descRice: "Do 10% of rice plants show drought-related nutrient deficiency symptoms?",
                },
                pest: {
                    title: "Pest check",
                    desc: "Do 10% of lychee trees show litchi stem borer damage?",
                },
            },
        },
        adjustPopup: {
            title: "Current date: {date}",
            selectPhenology: "Select phenological stage for {species}",
            selectReproductive: "Select reproductive stage for {species}",
            standard: "Criterion: over {ratio} of plants show this stage",
            ratio: "60%",
            selectPhenologyToast: "Please select phenological stage",
            selectReproductiveToast: "Please select reproductive stage",
        },
        agriFile: {
            farmName: "Farm Name",
            farmLocation: "Location",
            moreFarms: "More farms",
            patrolRecord: "Patrol records",
            patrolGrowthTitle: "Growth tracking patrol",
            patrolAbnormalTitle: "Abnormality patrol",
            patrolSubject: "Subject",
            patrolIssue: "Interaction questions interaction questions",
            forward: "Forward",
            workName: "Farm work name",
            interactTheme: "Interaction theme",
            interactReason: "Interaction reason",
            agriAssessment: "Agri assessment",
            agriAssessmentDesc: "Interaction reason interaction reason meteorological risk, etc.",
            interactQuestion: "Interactive question",
            interactQuestionText: "Specific question specific question specific question?",
            ratioPlaceholder: "Enter ratio",
            pleaseSelectOption: "Please select an option first",
            submit: "Submit",
            referenceImage: "Reference image",
            patrolGuide: "Patrol guide",
            growthAbnormal: "Growth abnormality",
            rootAbnormal: "Root abnormality",
            uploadPhoto: "Upload photo",
            pestInteract: "Pest interaction",
            selectAbnormalPlot: "Please select the plot where the anomaly occurred",
            confirmPlot: "Confirm plot",
            pleaseSelectPlot: "Please select a plot first",
            cancel: "Cancel",
            completeFarmInfo: "Complete farm info",
            getImmediately: "Get",
            patrolDiagnosisService: "field diagnosis now",
            goEnable: "Get started",
            plantingDiagnosisReport: "Planting diagnosis report",
            reportGenerated: "Generated",
            clickToView: "View now",
            viewInDiagnosisHint: "Also available in Crop Archives - Diagnosis report",
            initialReport: "Initial report",
            forwardReport: "Forward report",
            confirmLeaveTitle: "Leave this page?",
            confirmLeaveDesc1: "Growth patrol ratio is not entered yet. Leave anyway?",
            confirmLeaveDesc2: "Without this step, yield estimates will be less accurate~",
            continueRecord: "Keep recording",
            confirmLeave: "Leave",
            agriAlbum: "Agri album",
            diagnosisReport: "Diagnosis report",
            diagnosisReportGuidePrefix: "Follow patrol key points, ",
            diagnosisReportGuideSuffix: " to get a planting diagnosis report",
            reportUpdate: "Update",
            restoreFillQuestions: "Answer the questions",
            restorePlantingService: "Restore planting service",
            selectTime: "Select time",
            changeQuestion: "Change question",
            confirmNow: "Confirm now",
            submitInfo: "Submit",
            viewPatrolGuide: "View patrol guide",
            notReached: "Not reached",
            reached: "Reached",
            passed: "Passed",
            reportTitle: "Title",
            reportDesc: "Theme theme theme theme theme theme theme theme theme theme theme theme",
            reportDate: "Aug 30",
            addZone: "Add zone",
            drawFarmArea: "Draw area",
            addAlbum: "Add album",
            selectZoneHint: "Please select your zone area",
            drawFarmAreaHint: "Please draw the farm area",
            drawFarmAreaSuccess: "Farm area drawn successfully",
            searchLocation: "Search location",
            defaultCity: "Wuhan",
            cancelSelect: "Clear selection",
            plantCrop: "Planted crop",
            cropCategory: "Category",
            cropVariety: "Variety",
            plantStartPoint: "Planting start point",
            selectTime: "Select time",
            regionName: "Area name",
            regionNamePlaceholder: "Please enter area name",
            pleaseSelectCategory: "Please select a category",
            pleaseSelectVariety: "Please select a variety",
            pleaseSelectPlantDate: "Please select planting time",
            pleaseInputRegionName: "Please enter area name",
            confirmArea: "Confirm area",
            pleaseDrawZone: "Please draw a zone first",
            createZoneSuccess: "Zone created successfully",
            phenologyInconsistent: "Inconsistent phenology?",
            customizeZoneHint: "Customize zones to better record growth",
            zoneTwo: "Zone 2",
            photoCount: "{count} photos",
            emptyAlbumTip: "Upload crop photos to track growth",
            zoneLabel: "Zone {n}",
            zoneOne: "Zone 1",
            legendZone: "Management zone",
            legendGrowth: "Growth Abnormality",
            legendPest: "Pest &Disease",
            scaleNormal: "Normal",
            scaleGood: "Good",
            scaleExcellent: "Excellent",
            loading: "Loading...",
            noRecord: "No records",
            noData: "No data",
            tabPhenology: "Phenological Process",
            tabAbnormal: "Abnormalities",
            tabFarming: "Farm Work",
            tabAgriRecord: "Crop Records",
            cropArchive: "Crop archive",
            yearLabel: "{year}",
            cropArchiveMetric: "Some metric has reached 20% of the target",
            cropArchiveAbnormal: "Found *** abnormality",
            tabRemoteSensing: "Time-series Remote Sensing",
            remoteSensingChartTitle: "Time-series Remote Sensing Index",
            remoteSensingChartTitleNdvi: "NDVI",
            remoteSensingChartTitleNdwi: "NDWI",
            remoteSensingChartTitlePrecipitation: "Daily Precipitation",
            remoteSensingLegendZone: "Zone Index Curve",
            remoteSensingLegendStandard: "Standard Index Curve",
            remoteSensingLegendNdvi: "NDVI Curve",
            remoteSensingLegendNdwi: "NDWI Curve",
            remoteSensingLegendPrecipitation: "Precipitation",
            remoteSensingLegendAvgPrecipitation: "Avg. Precipitation",
            remoteSensingAxisIndex: "Index",
            remoteSensingAxisPrecipitation: "Precipitation",
            timeAxisLabel: "Time",
            remoteSensingValuePlaceholder: "Number",
            remoteSensingSelectHint: "Select a remote sensing index type from the left tabs to view time-series indicators",
            recordFruitExpand: "Rapid fruit expansion in orchard, ",
            recordFruitSet: "Flower drop and fruit set in orchard, ",
            recordFullBloom: "Orchard in full bloom",
            recordPanicle: "Panicle emergence in orchard",
            recordStemBorerFruit: "Stem borer damage on fruit in orchard, ",
            recordCalciumCrack: "Calcium deficiency fruit cracking in orchard, ",
            recordStinkBug: "Lychee stink bug nymph damage in orchard",
            recordFlowerNoFruit: "Flowering without fruit set in orchard",
            recordFertilize: "Fruit expansion fertilization applied",
            recordStemBorerControl: "Stem borer control applied",
            recordFlowerFruitProtect: "Flower and fruit protection spray applied",
            recordPreFlowerPest: "Pre-bloom pest control applied",
            recordNow: "Record Now",
            riskLevel1: "Level 1",
            riskLevel2: "Level 2",
            riskLevel3: "Level 3",
        },
        recordDetails: recordDetailsEn,
        agriRecord: {
            farmDetail: "Farm Details",
            allFarmWork: "All Farm Work",
            traceFarmWork: "Traceability",
            level2: "Level 2",
            riskLevel: "Level {level}",
            pendingRecord: "Pending",
            growthWorkName: "Growth Abnormality Tracking",
            growthReason: "Slow growth due to zinc deficiency",
            growthIssue: "Do 10% of lychee trees show fruit drop or cracking?",
            pestWorkName: "Pest & Disease Monitoring",
            pestReason: "Pests and diseases affecting crop growth",
            pestIssue: "Do 10% of lychee trees show litchi stem borer?",
            phenologyWorkName: "Phenology Tracking",
            phenologyReason: "Expected critical pest control period",
            phenologyIssue: "Have 60% of lychee trees entered color-change stage?",
            workStatus: {
                0: "Time Calib",
                1: "Trigger Patrol",
                2: "Pending",
                3: "Off",
                4: "Cert",
                5: "Void",
                6: "Done",
            },
        },
        workDetail: {
            title: "Work Details",
            certifiedSuccess: "Certified",
            ownedPlot: "Plot 1: ",
            executionArea: "Area",
            verified: "Cert",
            reason: "Reason",
            purpose: "Purpose",
            notes: "Notes",
            prescription: "Prescription",
            plantingPlan: "Planting plan",
            triggerCondition: "Trigger",
            executionMethod: "Method",
            executeParameters: "Parameters",
            agriMaterial: "Supplies",
            usageMethod: "Usage",
        },
        workExecute: {
            pending: "Pending",
            accepted: "Accepted",
            executing: "In progress",
            completed: "Completed",
            timeout: "Timed out",
            unqualified: "Below standard",
            acceptTimeout: "Acceptance abnormal",
            executeAbnormal: "Execution abnormal",
            completeAbnormal: "Completion abnormal",
            executeTimeout: "Execution overdue",
            completeTimeout: "Completion overdue",
            farmWorkType: "Farm work type",
            farmFilter: "Farm filter",
            batchAccept: "Batch accept",
            responsible: "Responsible: ",
            farmWorkDetail: "Details: ",
            farmSituation: "Assessment: ",
            executeTime: "Execution time",
            executeArea: "Execution area",
            executeMachine: "Machinery",
            executePhotos: "Execution photos",
            unqualifiedReason: "Reason: ",
            defaultUnqualifiedReason: "Not executed at the right time; spray was not fully absorbed",
            before: "Before",
            after: "After",
            fromFarm: "From demo farm",
            noData: "No farm tasks recently",
            all: "All",
            highRisk: "High risk",
            executeAreaLabel: "Execution area: ",
            forward: "Forward",
            viewDetail: "View details",
            forwardTip: "Forward feature coming soon",
            exclusiveFarmCalendar: "exclusive farm calendar",
            fillSurvey: "Fill out the survey",
            fillSurveyDesc: "Helps us assign farm tasks more easily",
            fillNow: "Fill in now",
            surveyEntryTitle: "Enter information",
            surveyEntryHint: "Select the farm work categories",
            surveyEntryHint2: "you want professional teams to handle",
            surveySearchPlaceholder: "Enter farm work category",
            surveySearch: "Search",
            surveySelectTitle: "Select farm work categories",
            surveySelectHint: "Multi-select",
            surveySubmit: "Submit",
            surveyPleaseSelect: "Please select at least one category",
            surveySubmitSuccess: "Submitted successfully",
            surveyNoMatch: "No matching categories",
            redispatch: "Redispatch",
            remindAccept: "Remind to accept",
            modifyInfo: "Edit info",
            acceptTask: "Accept",
            startExecute: "Start execution",
            markComplete: "I have completed",
            remindExecute: "Remind to execute",
            remindComplete: "Remind to complete",
            redispatchAgain: "Redispatch",
            remindSuccess: "Reminder sent!",
            redispatchMsg: "Redispatched: {name}",
        },
        uploadPopup: {
            uploadPhotos: "Upload photos",
            optional: "(Optional)",
        },
        agriRecordDetail: {
            title: "Work Details",
            deadlinePrefix: "Due by",
            executionArea: "Execution area",
            navigateHere: "Navigate here",
            workPurpose: "Purpose",
            drugPrescription: "Prescription",
            executionParams: "Execution parameters",
            precautions: "Precautions",
            cancelEdit: "Cancel",
            modifyInfo: "Edit info",
            saveInfo: "Save",
            acceptTask: "Accept",
            saveSuccess: "Saved successfully",
            acceptSuccessTitle: "Accepted successfully",
            acceptSuccessDesc: "Please complete the farm work within the scheduled time",
            executeSuccessTitle: "Farm task is now active",
            executeSuccessDesc: "Please execute on site as required",
            executeSuccessNotice: "Note: Take photos during execution and submit them for review after completion.",
            auditApproved: "Approved",
            completePopup: {
                selectExecuteTime: "Select actual execution time",
                evidenceTitle: "Farm work evidence",
                evidenceHint: "Please upload execution photos",
                confirm: "Confirm",
                selectTimeRequired: "Please select the actual execution time",
                uploadRequired: "Please upload execution photos",
                uploadFailed: "Image upload failed. Please try again later.",
            },
            selectDate: "Select date",
            pleaseInput: "Please enter",
            fields: {
                executor: "Responsible",
                workReasonDetail: "Work details",
                cropConditionAnalysis: "Crop assessment",
                workTime: "Execution time",
                executionMethod: "Execution parameters",
            },
            farmWorkType: {
                1: "Standard farm work",
                2: "Flexible farm work",
                3: "Weather alert work",
                4: "Weather recovery work",
                5: "Abnormal farm work",
                6: "Standard fertilization",
                7: "Standard prevention",
                8: "Standard regulation",
                91: "Standard sensing",
                92: "Nutrition assessment",
                93: "Phenology zoning",
                94: "Yield estimation",
                95: "Review sensing",
                96: "Weather stress",
                97: "Abnormal sensing",
                98: "Pest sensing",
            },
        },
    },
};
